export const templateComps = {
  confirmModal: {
    cancel: "إلغاء",
    delete: "حذف",
  },
  channexIncident: {
    kicker: "تنبيه مهم",
    brandTitle: "عطل خارجي",
    closeLabel: "إغلاق التنبيه",
    subtitle:
      "نراقب الوضع وسنراجع المزامنة بمجرد استعادة الخدمة.",
    title:
      "عطل عام في الاتصال مع Booking / Airbnb / مدير القنوات الخارجي",
    lead: "مرحبًا، نرصد عطلاً عامًا لدى مزوّد المزامنة الخارجي مع منصات الحجز (OTAs).",
    text: "يؤثر هذا العطل على واجهة برمجة التطبيقات (API) الخاصة به وقد يؤخّر مزامنة الحجوزات والإتاحة وإغلاق التواريخ.",
    note: "بمجرد عودة الاتصال إلى العمل، سنُجري مراجعة لمزامنة البيانات للتحقق من الحجوزات والإتاحة وإغلاق التواريخ.",
    textLast:
      "في WA Checkin سنراجع المزامنة بمجرد عودة الخدمة إلى العمل.",
    button: "حسنًا",
  },
  notificationsNav: {
    title: "الإشعارات",
    recent: "حديثة",
    emptyTitle: "لا توجد إشعارات",
    emptyText:
      "عند حدوث أمر مهم في حجوزاتك، سيظهر هنا.",
    seeAll: "عرض جميع الإشعارات",
    meta: {
      t1: { status: "جديدة", category: "حجز" },
      t2: { status: "محدّثة", category: "حجز" },
      t3: { status: "ملغاة", category: "حجز" },
      t4: { status: "مكتمل", category: "تسجيل الوصول" },
      t5: { status: "مطلوب", category: "خدمة" },
      t6: { status: "مستلمة", category: "طلب" },
      t7: { status: "موافق عليها", category: "طلب" },
      t8: { status: "مرفوضة", category: "طلب" },
      t9: { status: "مؤكّد", category: "دفع" },
      t10: { status: "قيد الدفع", category: "دفع معلّق" },
      t11: { status: "تخصيص غرفة", category: "حجز" },
      t12: { status: "فشل الإرسال", category: "تسجيل الوصول" },
      t13: { status: "لم يُرسل", category: "تسجيل المسافرين" },
      t15: { status: "مفعّل", category: "الاشتراك" },
      default: { status: "تنبيه", category: "النظام" },
    },
    typeLabel: {
      t1: "حجز جديد",
      t2: "تحديث الحجز",
      t3: "إلغاء الحجز",
      t4: "تسجيل الوصول",
      t5: "خدمة",
      t6: "طلب",
      t7: "طلب موافق عليه",
      t8: "طلب مرفوض",
      t10: "قيد الدفع",
      t11: "تخصيص غرفة",
      t12: "فشل الإرسال",
      t13: "تسجيل المسافرين",
      t15: "الاشتراك مفعّل",
      default: "إشعار",
    },
  },
};
